import { executeRequest, JFSRequest } from '@jfs/network'
import { jsonToGraphQLQuery } from 'json-to-graphql-query'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, sitConfigWithTraceId } from './config'

const responseParser = (response: any) => {
  return response?.data?.data !== null
    ? response?.data?.data
    : response?.data?.errors?.[0]?.exception?.emsErrorCodeDetailsDto?.channelDesc ??
        response?.data?.errors?.[0]?.exception?.message ??
        response?.data?.errors?.[0]?.message
}

const getSingleKeyRequestBody = (key: string) => {
  const queryObj = {
    findLov: {
      __args: {
        key: key,
      },
      key: true,
      value: true,
      description: true,
    },
  }
  const query = `{${jsonToGraphQLQuery(queryObj, { pretty: false })}}`
  console.log('getLovsReq query', query)
  return query
}
const getRequestBody = (
  key1: string,
  key2: string,
  key3: string,
  key4: string,
  key5: string,
  key6: string,
  key7: string,
  key8: string,
  key9: string,
  key10: string,
  key11: string,
  key12: string,
  key13: string,
  key14: string,
  key15: string,
) => {
  const queryObj = {
    findLov: {
      __args: {
        ...(key1 && { key1: key1 }),
        ...(key2 && { key2: key2 }),
        ...(key3 && { key3: key3 }),
        ...(key4 && { key4: key4 }),
        ...(key5 && { key5: key5 }),
        ...(key6 && { key6: key6 }),
        ...(key7 && { key7: key7 }),
        ...(key8 && { key8: key8 }),
        ...(key9 && { key9: key9 }),
        ...(key10 && { key10: key10 }),
        ...(key11 && { key11: key11 }),
        ...(key12 && { key12: key12 }),
        ...(key13 && { key13: key13 }),
        ...(key14 && { key14: key14 }),
        ...(key15 && { key15: key15 }),
      },
      key: true,
      value: true,
      description: true,
    },
  }

  const query = `{${jsonToGraphQLQuery(queryObj, { pretty: false })}}`
  console.log('getAllLovsReq query', query)
  return query
}

const getLovReq = (key: string, tokens: any, traceId: string) => {
  const request: JFSRequest<{}> = {
    apiPath: APIEndPoints.getAllLovs,
    method: 'POST',
    cache: false,
    config: sitConfigWithTraceId(tokens, traceId),
    headers: getHeaders(),
    body: getSingleKeyRequestBody(key),
  }
  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

const getAllLovsReq = (
  key1: string,
  key2: string,
  key3: string,
  key4: string,
  key5: string,
  key6: string,
  key7: string,
  key8: string,
  key9: string,
  key10: string,
  key11: string,
  key12: string,
  key13: string,
  key14: string,
  key15: string,
  tokens: any,
  traceId: string,
) => {
  const request: JFSRequest<{}> = {
    apiPath: APIEndPoints.getAllLovs,
    method: 'POST',
    cache: false,
    config: sitConfigWithTraceId(tokens, traceId),
    headers: getHeaders(),
    body: getRequestBody(
      key1,
      key2,
      key3,
      key4,
      key5,
      key6,
      key7,
      key8,
      key9,
      key10,
      key11,
      key12,
      key13,
      key14,
      key15,
    ),
  }
  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getAllLovsReq, getLovReq }
